module.exports = __webpack_public_path__ + "img/metaverse-banner-aside.8c3ba644.png";